import { Link } from 'react-router-dom';
import { Bars3Icon } from '@heroicons/react/24/outline';
import useUIStore from '../../store/uiStore';

export default function TopBar() {
  const { openMobileMenu } = useUIStore();

  return (
    <header className="h-14 flex items-center justify-between px-4 bg-theme-secondary border-b border-theme-primary safe-area-top transition-colors duration-300">
      {/* Menu Button */}
      <button
        onClick={openMobileMenu}
        className="p-2 -ml-2 rounded-xl hover:bg-theme-tertiary text-theme-muted hover:text-theme-primary transition-colors"
      >
        <Bars3Icon className="w-6 h-6" />
      </button>

      {/* Logo */}
      <Link to="/dashboard" className="flex items-center gap-2">
        <img
          src="/images/lensverse_logo.png"
          alt="LensVerse"
          className="h-8 w-8"
        />
        <span className="text-lg font-bold text-theme-primary">LensVerse</span>
      </Link>

      {/* Spacer for centering */}
      <div className="w-10" />
    </header>
  );
}
